<script setup lang="ts"></script>

<template>
  <div>
    <Navigation />
    <slot />
  </div>
</template>

<style scoped></style>
